import React from "react";
import { connect } from "react-redux";
import HeatmapLayer from "./HeatmapLayer";
// import {addressPoints} from './realworlddatapoint';

function HeatMapComponent(props) {
  const { heatMapData } = props;
  return (
    <HeatmapLayer
      fitBoundsOnLoad
      fitBoundsOnUpdate
      points={heatMapData}
      radius={35}
      gradient={{ 1.0: "#D13D29", 0.5: "#F49630", 0.25: "#70AD25" }}
      longitudeExtractor={(m) => m[1]}
      latitudeExtractor={(m) => m[0]}
      intensityExtractor={(m) => parseFloat(m[2])}
    />
  );
}

function mapStateToProps(state) {
  const { heatMapData } = state.map;
  return {
    heatMapData,
  };
}

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(HeatMapComponent);
